import { maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { AiImageGenerationResult } from "./types";

export const isAiImageGenerationResult = objectOf<AiImageGenerationResult>({
  status: number,
  result: maybe(string),
  message: maybe(string),
});
